export const getStyle = (type) => "text-align:left";

export const getFieldStyles = () => {
  return {
    field: [
      {
        backgroundColor: "lightGrey",
        fontSize: "14px",
        color: "blue",
      },
    ],
  };
};
